import * as React from 'react';
export const cryptoSvg = React.forwardRef(function cryptoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.625 3A.625.625 0 0 0 6 3.625v.91a4 4 0 0 0 0 6.93v.91a.625.625 0 1 0 1.25 0v-.446a4 4 0 0 0 1.5 0v.446a.625.625 0 1 0 1.25 0v-.91c.45-.261.845-.606 1.162-1.015.27-.35.103-.835-.293-1.031-.396-.196-.868-.02-1.182.29a2.402 2.402 0 1 1 .011-3.407c.313.312.784.492 1.18.299.398-.193.57-.678.301-1.029A4 4 0 0 0 10 4.536v-.911a.625.625 0 1 0-1.25 0v.446a4 4 0 0 0-1.5 0v-.446A.625.625 0 0 0 6.625 3Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z',
      clipRule: 'evenodd',
    }),
  );
});
cryptoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var crypto = {
  category: 'icon',
  colorable: true,
  name: 'crypto',
  svg: cryptoSvg,
};
